import { BaseApi } from '@shared/config';
import type {
  GetCompanyReviewsRequest,
  GetCompanyReviewsResponse,
} from './types';

class CompanyReviewApi extends BaseApi {
  getCompanyReviews = (
    params: GetCompanyReviewsRequest
  ): Promise<GetCompanyReviewsResponse> => {
    return this.instance.get('companies-rating', { params });
  };
}

export const companyReviewApi = new CompanyReviewApi();
